import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class CircleService {
  static async getCircles(params = {}) {
    const response = await axiosInstance.get(
      API_PATHS.getcircles,
      { params }
    );
    return response.data;
  }

  static async getCircleById(id) {
    const response = await axiosInstance.get(`admin/circles/${id}`);
    return response.data;
  }
  static async bulkCreateCircle(payload) {
    const response = await axiosInstance.post(
      API_PATHS.bulkcreatecircle,
      payload
    );

    return response.data;
  }


  static async createCircle(payload) {
    const response = await axiosInstance.post(
      API_PATHS.getcircles,
      payload
    );
    return response.data;
  }

  static async updateCircle(id, payload) {
    const response = await axiosInstance.put(
      `admin/circles/${id}`,
      payload
    );
    return response.data;
  }

  static async deleteCircle(id) {
    const response = await axiosInstance.delete(`admin/circles/${id}`);
    return response.data;
  }
}

export default CircleService;